<template>
  <div>
    <MenuCount_Stock/>
    <Count_List/>
  </div>
</template>

<script>
import MenuCount_Stock from "@/components/admin/count_stock/menucount_stock/MenuCount_Stock.vue";
import Count_List from "@/components/admin/count_stock/Count_List.vue";
export default {
  name: "CountList",
  components: {
    Count_List,
    MenuCount_Stock
  }
}
</script>

<style scoped>

</style>
